import axios from 'axios';
import {getDataOptions, postDataOptions} from './backendServices';
import {BASE_URL, COURSE_SERVICE_BASE_URL, PARTNER_BASE_URL} from './environments';

// APIs
const FORUM_DISCUSSION_API = 'admin/userQuery/getByChapter/';
const CHAPTER_REVIEW_API = 'course/reviewChapter';
const GET_ORG_DETAILS_BY_DOMAIN_API = 'api/org/fetch/domain';
const GET_HOME_BANNER_API = 'api/v1/home-banner/user';
const ELASTIC_SEARCH_API = 'elastic/search';
const WEBINARS_LIST_API = 'webinar/getAll/docpro';
const ACCREDITED_CME_API = 'recommendation/viewAll';
const WEBINARS_API = 'webinar/home/docpro';
const TESTIMONIAL_API = '/v1/testimonial/getByOrg/';
const TESTIMONIAL_SECTION_API = '/v1/testimonial/getByOrgAndSection/';
const TESTIMONIAL_TRACKER_API = 'v1/testimonial/v1/tracker';
const DOWNLOAD_TESTIMONIAL_DATA_API = 'api/testimonial/v1/download/userData?organizationId=';
const DOWNLOAD_WEBINAR_DATA_API = 'webinar/docpro/download?organizationId=';
const RATING_REVIEW_API = 'api/feedback/rating/review';
const GET_ADVERSTISEMENT_API = 'api/v1/org/getAdvertisements';
const ADVERSTISEMENT_ONCLICK_API = 'api/v1/org/userAdClick';
const GET_CUSTOM_SIGNUP_FIELDS = 'api/signupFields/getFields/{orgId}';
const UPLOAD_CUSTOM_FILE_SIGN_UP = 'api/signupFields/upload/multipartFile';
const RECOMMENDATIONS_API = 'recommendation';

// Services
export const forumDiscussionService = async (chapterId) => {
    try {
        const response = await axios(getDataOptions(COURSE_SERVICE_BASE_URL, FORUM_DISCUSSION_API + chapterId));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const chapterReviewService = async (payload) => {
    try {
        const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, CHAPTER_REVIEW_API, payload));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const ratingReviewService = async (productType) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, RATING_REVIEW_API + `?platformType=WEB&productType=${productType}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getOrgDetailsByDomainService = async (domainName) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, GET_ORG_DETAILS_BY_DOMAIN_API + `?domainName=${domainName}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getHomeBannerService = async (countryCode, organisationId) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, GET_HOME_BANNER_API + `?countryCode=${countryCode}&organisationId=${organisationId}&isExclusive=true`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const elasticSearchService = async (payload) => {
    try {
        const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, ELASTIC_SEARCH_API, payload));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const webinarsListService = async (orgId) => {
    try {
        const response = await axios(getDataOptions(COURSE_SERVICE_BASE_URL, WEBINARS_LIST_API + `?orgId=${orgId}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const accreditedCmeService = async (category, organizationId, pageNumber, pageSize) => {
    try {
        const payload = {
            category: category,
            screen: 'ORGANIZATION_LANDING_PAGE',
            organizationIds: [organizationId],
            pageNumber: pageNumber,
            pageSize: pageSize
        }
        const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, ACCREDITED_CME_API, payload));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const webinarsService = async (orgId) => {
    try {
        const response = await axios(getDataOptions(COURSE_SERVICE_BASE_URL, WEBINARS_API + `?orgId=${orgId}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getTestimonialService = async (orgId) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, TESTIMONIAL_API + orgId));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getTestimonialSectionService = async (orgId, sectionId) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, TESTIMONIAL_SECTION_API + `${orgId}/${sectionId}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const testimonialTrackerService = async (payload) => {
    try {
        const response = await axios(postDataOptions(BASE_URL, TESTIMONIAL_TRACKER_API, payload));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const downloadTestimonialDataService = async (orgId, accessToken) => {
    try {
        const headerConfiguration = {
            headers: {
                'Content-Type': 'application/json',
                'hk-access-token': accessToken,
            },
            responseType: 'blob',
        };
        const response = await axios.get(PARTNER_BASE_URL + DOWNLOAD_TESTIMONIAL_DATA_API + orgId, headerConfiguration);
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const downloadWebinarDataService = async (orgId, accessToken) => {
    try {
        const headerConfiguration = {
            headers: {
                'Content-Type': 'application/json',
                'hk-access-token': accessToken,
            },
            responseType: 'blob',
        };
        const response = await axios.get(COURSE_SERVICE_BASE_URL + DOWNLOAD_WEBINAR_DATA_API + orgId, headerConfiguration);
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getAdvertisementsService = async (orgId) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, GET_ADVERSTISEMENT_API + `?orgId=${orgId}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const advertisementsClickService = async (orgId, adId, device) => {
    try {
        const response = await axios(getDataOptions(BASE_URL, ADVERSTISEMENT_ONCLICK_API + `?orgId=${orgId}&adId=${adId}&device=${device}`));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getCustomSignUpFieldsService = async (orgId) => {
    try {
        const url = GET_CUSTOM_SIGNUP_FIELDS.replace('{orgId}', orgId);
        const response = await axios(getDataOptions(BASE_URL, url));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const uploadCustomFileSignUpService = async (payload) => {
    try {
        const response = await axios(postDataOptions(BASE_URL, UPLOAD_CUSTOM_FILE_SIGN_UP, payload, true));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const getRecommendationsService = async (payload) => {
    try {
        const response = await axios(postDataOptions(COURSE_SERVICE_BASE_URL, RECOMMENDATIONS_API, payload));
        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};
